export default "__VITE_ASSET__C1LTte2Z__"